import { AddTrainingEventSubscriptionRequestArray } from './add.training.event.subscription.request';

export class AddTrainingEventRequest {
    EventDateTime: Date;
    TrainingClassID: number;
    TrainerID: number;
    NewAttendees: AddTrainingEventSubscriptionRequestArray;
    GoToMeetingLink: string;
    WebinarID: string;
}
